<beautyapp-select-search
  class="search-input"
  [data]="customers"
  placeholder="header.search.placeholder"
  (onSearch)="searchCustomer($event)"
  [ngModel]="appointmentSearch"
  (ngModelChange)="searchAppointment($event)"
  valueMember="id"
  displayMember="fullName"
  prefixIcon="user"
></beautyapp-select-search>
@if (userBookings$ | async; as userBookings) {
  @if (userBookings.length) {
    <div class="search-area">
      <div nz-row [nzGutter]="[8, 8]">
        @for (userBooking of userBookings; track userBooking) {
          <div
            nz-col
            [nzSpan]="6"
            (click)="openBook(userBooking)"
            nzFlex="stretch"
            >
            <nz-list nzBordered nzSize="small">
              <nz-list-header
                >{{'findReservation.reservation' | translate}}: {{ userBooking?.bookingDate }}
                {{ userBooking?.startTime }} -
                {{ userBooking?.endTime }}</nz-list-header
                >
                <nz-list-item>
                  {{'findReservation.employee' | translate}}: {{ userBooking?.employee?.user?.firstname }}
                  {{ userBooking?.employee?.user?.lastname }}</nz-list-item
                  >
                  <nz-list-item
                    >{{'findReservation.user' | translate}}: {{ userBooking?.user?.firstname }}
                    {{ userBooking?.user?.lastname }}</nz-list-item
                    >
                    <nz-list-item
                      >{{'findReservation.phoneNumber' | translate}}: {{ userBooking?.user?.mobilePhone }}</nz-list-item
                      >
                      <nz-list-item
                        >{{'findReservation.procedure' | translate}}: {{ userBooking?.service?.name }}</nz-list-item
                        >
                        <nz-list-footer>{{'findReservation.price' | translate}}: {{ userBooking?.price }} {{'findReservation.gel' | translate}}</nz-list-footer>
                      </nz-list>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="search-area">
                <nz-empty></nz-empty>
              </div>
            }
          }
